import { useQuery } from "@tanstack/react-query";
import { adaptObservationForm } from "src/adapters";
import cmsClient from "src/services/cmsClient";

interface Options {
	onSuccess?: ((data: ObservationForm) => void) | undefined;
}

const select = adaptObservationForm;

const fetchObservationFormById = async (id: number) => {
	const url = `/observations/forms/${id}/`;

	const response = await cmsClient.get<IObservationForm>(url);
	return response.data;
};

const useObservationFormQuery = (id: number, options?: Options) => {
	return useQuery(["observationForm", id], () => fetchObservationFormById(id), {
		select,
		onSuccess: options?.onSuccess
	});
};

export default useObservationFormQuery;
